module.exports = __webpack_public_path__ + "img/check-success.fc469ae2.svg";